import React, { Fragment, ReactElement } from "react";

import { LogicalDevice } from "@sportal/api";

export interface AdvancedColumn {
  header: ReactElement;
  renderValue: (device) => ReactElement | string;
}

interface ColumnTextProps {
  header: ReactElement;
  value: ReactElement | string;
}

const ColumnText = ({ header, value }: ColumnTextProps) => {
  return (
    <Fragment>
      {header}: {value}
    </Fragment>
  );
};

interface AriaAdvancedColumnProps {
  columns: AdvancedColumn[];
  device: LogicalDevice;
}

export const AriaAdvancedColumn = ({
  columns,
  device,
}: AriaAdvancedColumnProps) => {
  if (columns.length === 1) {
    return (
      <ColumnText
        header={columns[0].header}
        value={columns[0].renderValue(device)}
      />
    );
  }

  return (
    <div role="list" className="aria-advanced-column">
      {columns.map(({ header, renderValue }, index) => {
        return (
          <div role="listitem" key={index}>
            <ColumnText header={header} value={renderValue(device)} />
          </div>
        );
      })}
    </div>
  );
};
